import integration from "@/store/integration";
import reports from "@/store/reports";
import testDetail from "@/store/testDetail";
import testListing from "@/store/testListing";
import dialog from "@/store/dialog";

export default {
  integration,
  reports,
  testDetail,
  dialog,
  testListing,
};
